module.exports = `${require.publicPath}plan-banner-bg.36097d1c.png`;